/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, details: NonNullable<unknown> }} Workout_Share_Analysis_Question_OnInputs */

const en_us2_workout_share_analysis_question_on = /** @type {(inputs: Workout_Share_Analysis_Question_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Review my workout from ${i?.date} (${i?.details}): what went well and what should I adjust next time?`)
};

const pt_br2_workout_share_analysis_question_on = /** @type {(inputs: Workout_Share_Analysis_Question_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Analise meu treino de ${i?.date} (${i?.details}): o que foi bem e o que ajustar no próximo?`)
};

const es_419_workout_share_analysis_question_on = /** @type {(inputs: Workout_Share_Analysis_Question_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Analiza mi entrenamiento del ${i?.date} (${i?.details}): ¿qué salió bien y qué debo ajustar la próxima vez?`)
};

const pt_pt2_workout_share_analysis_question_on = /** @type {(inputs: Workout_Share_Analysis_Question_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Analisa o meu treino de ${i?.date} (${i?.details}): o que correu bem e o que devo ajustar no próximo?`)
};

const fr_fr2_workout_share_analysis_question_on = /** @type {(inputs: Workout_Share_Analysis_Question_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Analyse ma séance du ${i?.date} (${i?.details}) : qu'est-ce qui s'est bien passé et que dois-je ajuster la prochaine fois ?`)
};

const de_de2_workout_share_analysis_question_on = /** @type {(inputs: Workout_Share_Analysis_Question_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Analysiere mein Training vom ${i?.date} (${i?.details}): Was lief gut und was sollte ich beim nächsten Mal anpassen?`)
};

const it_it2_workout_share_analysis_question_on = /** @type {(inputs: Workout_Share_Analysis_Question_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Analizza il mio allenamento del ${i?.date} (${i?.details}): cosa è andato bene e cosa dovrei cambiare la prossima volta?`)
};

/**
* | output |
* | --- |
* | "Review my workout from {date} ({details}): what went well and what should I adjust next time?" |
*
* @param {Workout_Share_Analysis_Question_OnInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_analysis_question_on = /** @type {((inputs: Workout_Share_Analysis_Question_OnInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Analysis_Question_OnInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_analysis_question_on(inputs)
	if (locale === "es-419") return es_419_workout_share_analysis_question_on(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_analysis_question_on(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_analysis_question_on(inputs)
	if (locale === "de-DE") return de_de2_workout_share_analysis_question_on(inputs)
	if (locale === "it-IT") return it_it2_workout_share_analysis_question_on(inputs)
	return en_us2_workout_share_analysis_question_on(inputs)
});
export { workout_share_analysis_question_on as "workout-share.analysis_question_on" }